import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { defaultMemoize } from 'reselect';
import BalanceSellingView from './BalanceSelling.view';
import { getRankedAccountsWithRank } from '../WorkArea.selectors';
import Http from '../../../libs/Http';

export class BalanceSellingContainer extends Component {

  constructor(props) {
    super(props);

    this.onFilterFormChange = this.onFilterFormChange.bind(this);

    this.state = {
      transactions: null,
      orderTotal: null,
      amountTotal: null,
      ordersCount: {
        success: 0,
        failure: 0,
      },
      clients: [],
      filtersFormState: {
        data: {
          client: '',
          // date: moment().startOf('day').format('YYYY-MM-DD'),
          date: moment().format('YYYY-MM-DD'),
        },
      },
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      $global: true,
      type: 'FETCH_AMAZON_BALANCES',
    });
    return this.fetchTransactions();
  }

  onFilterFormChange(filtersFormState) {
    this.setState({
      filtersFormState,
    }, () => this.fetchTransactions());
  }

  async fetchTransactions() {
    const { client, date } = this.state.filtersFormState.data;
    const from = moment(date).startOf('day').toDate().getTime();
    const to = from + (24 * 60 * 60 * 1000);
    const { transactions, orderTotal, amountTotal, ordersCount, clients } = await Http.get('/data/balancesSellingTransactions', {
      query: {
        client,
        from,
        to,
      },
    });
    this.setState({
      transactions,
      orderTotal,
      amountTotal,
      ordersCount,
      clients: [''].concat(clients),
    });
  }

  render() {
    return (<BalanceSellingView
      {...this.props}
      {...this.state}
      onFilterFormChange={this.onFilterFormChange}
    />);
  }

}

function mapStateToProps(state) {
  const { dynamicData } = state;
  const { amazonBalances } = dynamicData;
  return {
    amazonBalances,
    rankedAccounts: getRankedAccountsWithRank(state),
  };
}

export default connect(mapStateToProps)(BalanceSellingContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BalanceSelling/BalanceSelling.container.js